import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useAccount } from '../contexts/AccountContext';
import VendorDetailPage from './VendorDetailPage';
import './OhipTransactionsPage.css';     // .otx-page
import './TaskConfigurationPage.css';   // .empty-state

// VENDOR SETTINGS — what a person who works at a vendor sees of their own vendor.
//
// A THIN ADAPTER over VendorDetailPage (the partner admin's view of the same vendor), opened read-only on the
// vendor named by the person's own users row (session `vendorOf`). Never an id from the URL: there is exactly
// one vendor that is theirs, and the lambda refuses any other with a 404.
//
// The sidebar offers it only while the partner they are a vendor FOR is chosen in the navbar. Reached any
// other way — a bookmark, another partner chosen — it says so rather than redirecting (a mismatched navbar
// is a confusing view, not a breach).
const VendorSettings = () => {
    const { vendorOf } = useAuth();
    const { selectedPartner } = useAccount();

    if (!vendorOf) {
        return (
            <div className="otx-page">
                <div className="empty-state">
                    <AlertCircle className="empty-icon" />
                    <p>You do not work at a vendor, so there are no vendor settings to show.</p>
                </div>
            </div>
        );
    }

    if (Number(selectedPartner) !== Number(vendorOf.partnerId)) {
        return (
            <div className="otx-page">
                <div className="empty-state">
                    <AlertCircle className="empty-icon" />
                    <p>Choose the partner you are a vendor for in the navigation bar to see {vendorOf.name}'s settings.</p>
                </div>
            </div>
        );
    }

    return <VendorDetailPage vendorId={vendorOf.credentialId} selfView />;
};

export default VendorSettings;
